import React from "react";
import "./Banner.css";
import { useNavigate } from "react-router-dom";

const Banner = ({ hero }) => {
  const navigate = useNavigate();
  return (
    <div className="Banner">
      <div className="banner-image">
        <img src={hero?.background?.url} alt="" />
      </div>
      <div className="Banner-box">
        <h1>{hero?.Heading}</h1>
        <h2>{hero?.description1}</h2>
        <h2>{hero?.description2}</h2>
        <div className="banner-item-btn">
          <button
            className="btn-fill"
            onClick={() => navigate(hero?.primaryLink)}
          >
            {hero?.primaryButton}
          </button>
          <button
            className="btn-outline"
            onClick={() => navigate(hero?.secondaryLink)}
          >
            {hero?.secondaryButton}
          </button>
        </div>
      </div>
      <div className="banner-shape1"></div>
    </div>
  );
};

export default Banner;
